import { PropertiesService } from './properties.service';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Juror, CreazioneUtenteResponse } from "../interfaces/juror";
import { BaseResponse } from "../interfaces/utilities";

@Injectable({
	providedIn: "root"
})
export class JurorService {
	checkToken(tokenObj: { idUtente: any; token: any; }) : Observable<BaseResponse> {
		return this.httpClient.post<BaseResponse>(
			`${this.propService.getProp('apiPrefix')}/api/Public/Utente/ConfermaToken`, tokenObj
		);
	}
    constructor(private httpClient: HttpClient, private propService: PropertiesService) {}
    


	createJuror(juror: Juror): Observable<CreazioneUtenteResponse> {
		return this.httpClient.post<CreazioneUtenteResponse>(
			`${this.propService.getProp('apiPrefix')}/api/Public/Utente/CreazioneGiurato`, juror
		);
	}

	getInfoJurato(id: string) : Observable<any> {
		return this.httpClient.get<any>(
			`${this.propService.getProp('apiPrefix')}/api/Public/Utente/InfoGiurato?id=${id}`
		);
	}
}
